import { useEffect, useState } from 'react'
import { inject, observer } from 'mobx-react';
import FormMaster from '../FormMaster'
import { CommonService } from "../../../services";
import { isEmpty } from 'lodash';
import { useTranslation } from 'react-i18next'

let firstRender = false
const MaintenanceTypeUnit = inject("authenStore")(observer((props) => {
  const { t } = useTranslation(['maintenance-type', 'common'])
  let authenStore = props.authenStore
  let { getAccountAuth } = authenStore // STATE
  let auth = { action_user_id: getAccountAuth?.user_id, token_id: getAccountAuth?.access_token }

  const [optionStatus, setOptionStatus] = useState([])

  useEffect(() => {
    if (firstRender || !isEmpty(getAccountAuth)) {
      CommonService.getMasterData(auth, "common_status")
        .then((res: any) => {
          let common_status = res.result.common_status.map((item) => ({ label: item.status_name, value: item.status_code }))
          setOptionStatus(common_status)
        })
        .catch((err) => {
          console.log(`Load master data : ${err}`)
        })
    }
    else
      firstRender = true
  }, [getAccountAuth])

  return <FormMaster
    title={t('maintenance_type_information')}
    tableConfig={{
      key: "id",
      apiPath: "maintain/list",
      allowDelete: {
        visible: true,
        key: "ma_item_id",
        apiPath: "maintain/delete",
        paramType: "param"
      },
      optionDeleteFag: true,
      defaultColumn: [],
      columns: [
        {
          dataField: 'no',
          caption: t('no'),
          width: 60,
          alignment: "center",
          allowFiltering: false
        },
        {
          dataField: 'ma_item_code',
          caption: t('code'),
          allowFiltering: true
        },
        {
          dataField: 'ma_item_name',
          caption: t('type_name'),
          allowFiltering: true
        },
        {
          dataField: 'target_km',
          caption: t('distance_change_km'),
          alignment: "start"
        },
        {
          dataField: 'warning_target_km',
          caption: t('distance_advance_warning_km'),
          alignment: "start"
        },
        {
          dataField: 'target_day',
          caption: t('time_to_change_day'),
          alignment: "start"
        },
        {
          dataField: 'warning_target_day',
          caption: t('distance_advance_warning_day'),
          alignment: "start"
        },
        {
          dataField: 'status_name',
          caption: t('status'),
          allowFiltering: true
        },
        {
          dataField: 'updated_by',
          caption: t('edit_by'),
        }
      ],
      exportExcel: {
        fileName: t('maintenance_type_information'),
        columnConfig: [
          { label: t('no'), value: 'no' },
          { label: t('code'), value: 'ma_item_code' },
          { label: t('type_name'), value: 'ma_item_name' },
          { label: t('distance_change_km'), value: 'target_km' },
          { label: t('distance_advance_warning_km'), value: 'warning_target_km' },
          { label: t('time_to_change_day'), value: 'target_day' },
          { label: t('distance_advance_warning_day'), value: 'warning_target_day' },
          { label: t('status'), value: 'status_name' },
          { label: t('edit_by'), value: 'updated_by' }
        ]
      }
    }}
    formData={{
      ma_item_code: "",
      ma_item_name: "",
      target_km: "",
      warning_target_km: "",
      target_day: "",
      warning_target_day: "",
      update_mode: "",
      status: "Y"
    }}
    modalConfig={{
      visible: true,
      title: t('maintenance_type_information'),
      required: ["ma_item_code", "ma_item_name", "update_mode"],
      fieldTypeNumber: [],
      paramName: "ma_item_id",
      apiPath: {
        "get": '',
        "post": 'maintain/add',
        "put": 'maintain/update'
      },
      elements: [
        {
          fieldName: "ma_item_code",
          label: t('code'),
          placeholder: t('code'),
          required: true,
          inputType: "text"
        },
        {
          fieldName: "ma_item_name",
          label: t('type_name'),
          placeholder: t('type_name'),
          required: true,
          inputType: "text"
        },
        {
          fieldName: "target_km",
          label: t('distance_change_km'),
          placeholder: t('distance_change_km'),
          min: 0,
          inputType: "number",
          isOneRow: true
        },
        {
          fieldName: "warning_target_km",
          label: t('distance_advance_warning_km'),
          placeholder: t('distance_advance_warning_km'),
          min: 0,
          inputType: "number",
          isOneRow: true
        },
        {
          fieldName: "target_day",
          label: t('time_to_change_day'),
          placeholder: t('time_to_change_day'),
          min: 0,
          inputType: "number",
          isOneRow: true
        },
        {
          fieldName: "warning_target_day",
          label: t('distance_advance_warning_day'),
          placeholder: t('distance_advance_warning_day'),
          min: 0,
          inputType: "number",
          isOneRow: true
        },
        {
          fieldName: "update_mode",
          label: t('update_mode'),
          required: true,
          placeholder: t('update_mode'),
          inputType: "select",
          allowClear: true,
          options: [
            {
              label: "ปรับปรุงรถทั้งหมด",
              value: 1
            },
            {
              label: "ปรับปรุงรถเฉพาะรถใหม่",
              value: 2
            }
          ]
        },
        {
          showSearch: false,
          fieldName: "status",
          label: t('status'),
          placeholder: t('status'),
          inputType: "select",
          defaultValue: "Y",
          options: optionStatus
        }
      ]
    }}
  />
}))

export default MaintenanceTypeUnit